<div class="col-md-12">
  <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section  m-accordion--toggle-arrow" id="m_accordion_7"
    role="tablist">
    <div class="m-accordion__item" *ngFor="let item of attribute.attributes">
        <div class="m-accordion__item-head" role="tab" [id]="'m_accordion_7_'+getOptionByKey(item,'identifier')+'_head'"
          data-toggle="collapse" aria-expanded="false">
          <span class="m-accordion__item-icon">
            <i class="fa fa-file-text"></i>
          </span>
          <span class="m-accordion__item-title">
            {{item.key}}
          </span>
          <span class="m-accordion__item-mode"></span>
        </div>
        <div class="m-accordion__item-body collapse" [id]="'m_accordion_7_'+getOptionByKey(item,'identifier')+'_body'"
          role="tabpanel" data-parent="#m_accordion_7">
          <div class="m-accordion__item-content">
            <app-dynamic *ngFor="let itemAttributes of item.attributes" [attribute]="itemAttributes"></app-dynamic>
          </div>
        </div>
      </div>
  </div>
</div>

